import toast from "react-hot-toast";
import api from "./axiosInstance";
import { unifiedLogout } from "./axiosInstance";
//CHAT API
export const getBotResponse = async (
  user_msg,
  contextArr,
  time,
  session_id,
  message_id,
  state
) => {
  let history = [];
  let userMessage = "";
  let assistantResponse = "";
  let userQueryTime = "";

  if (contextArr.length > 0) {
    contextArr.forEach((item) => {
      if (item.from === "User") {
        userMessage = item.message;
        userQueryTime = item?.time;
      } else if (item.from === "Bot") {
        assistantResponse = item?.message;
        history.push({
          user: userMessage,
          assistant: assistantResponse,
          time: userQueryTime,
        });
      }
    });
  }

  const payload = {
    question: user_msg,
    history: history,
    user_id: localStorage.getItem("userId"),
    time: time,
    session_id: session_id,
    category: "",
    message_id: message_id,
    state: state,
  };

  try {
    const response = await api.post("/default_chat", payload, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "69420",
      },
    });

    if (response.status === 200) {
      await refreshSidebar();
    }

    return response.data; // axios auto-parses JSON
  } catch (error) {
    console.error("Error in getBotResponse:", error);

    // 🔹 Extra 401 check (backup if interceptor didn’t fire)
    if (error?.response?.status === 401) {
      console.warn("401 detected in getBotResponse → triggering logout");
      await unifiedLogout(); // reuse the same logout function
    }

    throw error;
  }
};
export const getAudioSummarize = async (form) => {
  try {
    const response = await api.post("/upload_audio", form, {
      headers: {
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "69420",
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const saveNewUpdatedSummary = async (summary, file_name) => {
  try {
    const response = await api.post("/process_and_upload", {
      summary,
      file_name,
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
// The multi-model comparison (Phase-3) has been retired — gpt-5.4-mini won
// and is now the sole champion model. This list is kept at one entry (rather
// than removed outright) so multiChatAllModels/ModelDropdown below, which
// still expect a model list, keep working unchanged with a single model.
export const MODEL_LIST = [
  { name: "Model 1", value: "gpt-5.4-mini", endpoint: "/default_chat" },
];

// Fans a single question out to all MODEL_LIST endpoints simultaneously.
// onModelUpdate(modelValue, patch) fires as soon as each model settles (or starts),
// so the caller can render whichever model responds first without waiting on the rest.
export const multiChatAllModels = async (
  user_msg,
  contextArr,
  time,
  session_id,
  message_id,
  state,
  onModelUpdate
) => {
  let history = [];
  let userMessage = "";
  let assistantResponse = "";
  let userQueryTime = "";

  if (contextArr.length > 0) {
    contextArr.forEach((item) => {
      if (item.from === "User") {
        userMessage = item.message;
        userQueryTime = item?.time;
      } else if (item.from === "Bot") {
        assistantResponse = item?.message;
        history.push({
          user: userMessage,
          assistant: assistantResponse,
          time: userQueryTime,
        });
      }
    });
  }

  const payload = {
    question: user_msg,
    history,
    user_id: localStorage.getItem("userId"),
    time,
    session_id,
    category: "",
    message_id,
    state,
  };

  const results = await Promise.allSettled(
    MODEL_LIST.map(async ({ value, endpoint }) => {
      onModelUpdate(value, { status: "pending" });
      const startedAt = performance.now();
      try {
        const response = await api.post(endpoint, payload, {
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "69420",
          },
        });
        const responseTimeMs = performance.now() - startedAt;
        onModelUpdate(value, { status: "done", ...response.data, responseTimeMs });
      } catch (error) {
        const responseTimeMs = performance.now() - startedAt;
        console.error(`Error fetching model ${value}:`, error);
        if (error?.response?.status === 401) {
          await unifiedLogout();
        }
        onModelUpdate(value, { status: "error", responseTimeMs });
        throw error;
      }
    })
  );

  return results;
};
export const newSession = async () => {
  try {
    const response = await api.get("/new_chat", {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "69420",
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const refreshSidebar = async () => {
  const data = { user_id: localStorage.getItem("userId") };

  try {
    const response = await api.post("/chat_history", data);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const handleDeleteSession = async (sessionId) => {
  const data = { session_id: sessionId };

  try {
    const response = await api.post("/delete_chat", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      await refreshSidebar(); // ✅ trigger sidebar refresh
    }

    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const handleLikeMsg = async (item) => {
  const data = {
    user_id: item.user_id,
    session_id: item.session_id,
    message_id: item.message_id,
    feedback: "thumbs_up",
  };

  try {
    const response = await api.post("/submit_feedback", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("Thanks for your feedback! 👍");
      // Call refreshSidebar on success if needed
      // await refreshSidebar();
    }

    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const handleDislikeMsg = async (item) => {
  const data = {
    user_id: item.user_id,
    session_id: item.session_id,
    message_id: item.message_id,
    feedback: "thumbs_down",
    feedback_text: item.comment,
    category: item.category,
    feedback_type: item.feedback_type,
    user_info: {
      email: item.email,
      firstname: item.name,
      lastname: item.family_name,
      state: item.state,
    },
  };

  try {
    const response = await api.post("/submit_feedback", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      toast.success(response.data.message);
      // Uncomment if sidebar refresh is needed
      // await refreshSidebar();
    }

    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const updateKnowledge = async () => {
  try {
    const response = await api.post("/sharepoint_trigger", null, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Fire-and-forget sync has no synchronous completion signal — the caller
// should poll this for status to flip from "running" to "idle" rather than
// assume the sync is done once updateKnowledge()'s POST resolves.
export const getSharepointSyncStatus = async () => {
  try {
    const response = await api.get("/sharepoint_sync_status");
    return response.data || { status: "idle", last_completed_at: null };
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const checkAdminStatus = async (userId, retryCount = 0) => {
  const data = {
    user_id: userId,
  };

  const maxRetries = 2;
  const retryDelay = 1000; // 1 second

  try {
    console.log(`Checking admin status for user: (attempt ${retryCount + 1})`);
    
    const response = await api.post("/check_user", data, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 10000, // 10 second timeout
    });
    return response;
  } catch (error) {
    console.error(`Admin status check failed (attempt ${retryCount + 1}):`, error);
    
    // Retry logic for network errors or 5xx errors
    if (retryCount < maxRetries && 
        (error.code === 'NETWORK_ERROR' || 
         error.code === 'ECONNABORTED' ||
         (error.response && error.response.status >= 500))) {
      
      console.log(`Retrying admin status check in ${retryDelay}ms...`);
      await new Promise(resolve => setTimeout(resolve, retryDelay));
      return checkAdminStatus(userId, retryCount + 1);
    }
    
    // For 401 errors, don't retry - let the auth interceptor handle it
    if (error.response && error.response.status === 401) {
      console.warn('Admin status check failed with 401 - authentication issue');
      throw error;
    }
    
    // For other errors, throw with more context
    const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
    throw new Error(`Admin status check failed: ${errorMessage}`);
  }
};
export const handleIncorrectMsg = async (item) => {
  const data = {
    user_id: item.user_id,
    session_id: item.session_id,
    message_id: item.message_id,
    feedback: "incorrect_thumbs_down",
  };

  try {
    const response = await api.post("/submit_feedback", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("idToken")}`,
      },
    });

    if (response.status === 200) {
      toast.success(response.data.message);

      try {
        await refreshSidebar();
      } catch (refreshError) {
        console.error("Sidebar refresh failed:", refreshError);
      }
    }

    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- Admin panel: user management (SQL-backed, replaces the Excel-based
// admin list) ---
export const searchUsers = async (query) => {
  try {
    const response = await api.get("/admin/search_users", {
      params: { query },
    });
    return response.data?.users || [];
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const listAdminUsers = async () => {
  try {
    const response = await api.get("/admin/users");
    return response.data?.users || [];
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const setAdminStatus = async (email, isAdmin, displayName) => {
  try {
    const response = await api.post("/admin/set_admin_status", {
      email,
      is_admin: isAdmin,
      display_name: displayName || null,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Pass an email to scope to one user (e.g. the logged-in admin's own usage);
// omit it for the all-up, every-user breakdown.
export const getUsageSummary = async (userId, range = "all") => {
  try {
    const params = { range };
    if (userId) params.user_id = userId;
    const response = await api.get("/admin/usage_summary", { params });
    return response.data?.usage || [];
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Returns {questions, total} — real server-side paging/filtering/sorting
// (see CosmosLogger.get_recent_questions), not a client-side slice over a
// fixed capped fetch, so page navigation stays correct at any data volume.
export const getRecentQuestions = async ({
  limit = 25,
  skip = 0,
  userId = "",
  search = "",
  sortBy = "time",
  sortDir = "desc",
  dateFrom = "",
  dateTo = "",
} = {}) => {
  try {
    const response = await api.get("/admin/recent_questions", {
      params: {
        limit, skip, user_id: userId, search, sort_by: sortBy, sort_dir: sortDir,
        date_from: dateFrom, date_to: dateTo,
      },
    });
    return {
      questions: response.data?.questions || [],
      total: response.data?.total || 0,
    };
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Every distinct user who has asked a question — backs the Recent Query Log
// table's "All Users" filter dropdown.
export const getDistinctUsers = async () => {
  try {
    const response = await api.get("/admin/distinct_users");
    return response.data?.users || [];
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Batch-resolves emails to real Entra display names, for the Activity Log
// usage charts. Returns {} on failure rather than throwing — callers should
// just fall back to showing the raw email.
export const resolveDisplayNames = async (emails) => {
  if (!emails || emails.length === 0) return {};
  try {
    const response = await api.get("/admin/resolve_display_names", {
      params: { emails: emails.join(",") },
    });
    return response.data?.names || {};
  } catch (error) {
    return {};
  }
};

// --- Semantic cache controls (admin only) ---
export const getSemanticCacheEnabled = async () => {
  try {
    const response = await api.get("/settings/semantic_cache_enabled");
    return !!response.data?.enabled;
  } catch (error) {
    return false;
  }
};

export const setSemanticCacheEnabled = async (enabled) => {
  try {
    const response = await api.post("/admin/semantic_cache_enabled", { enabled });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getSemanticCacheThreshold = async () => {
  try {
    const response = await api.get("/settings/semantic_cache_threshold");
    return response.data?.threshold;
  } catch (error) {
    return null;
  }
};

export const setSemanticCacheThreshold = async (threshold) => {
  try {
    const response = await api.post("/admin/semantic_cache_threshold", { threshold });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const clearSemanticCache = async () => {
  try {
    const response = await api.post("/admin/semantic_cache_clear");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getSemanticCacheExclusions = async () => {
  try {
    const response = await api.get("/settings/semantic_cache_exclusions");
    return response.data?.exclusions || [];
  } catch (error) {
    return [];
  }
};

export const addSemanticCacheExclusion = async (term) => {
  try {
    const response = await api.post("/admin/semantic_cache_exclusions", { term });
    return response.data?.exclusions || [];
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteSemanticCacheExclusion = async (termId) => {
  try {
    const response = await api.delete(`/admin/semantic_cache_exclusions/${termId}`);
    return response.data?.exclusions || [];
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getMkbDocuments = async () => {
  try {
    const email = localStorage.getItem("userId") || "";
    const response = await api.get("/admin/mkb_documents", { params: { email } });
    return { documents: response.data?.documents || [], lastSynced: response.data?.last_synced || null };
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Fire-and-forget — the backend runs this in the background and responds
// immediately (a synchronous multi-minute call here used to hit nginx's
// gateway timeout in prod, same issue as /sharepoint_trigger). Callers
// should poll getMkbDocuments() for lastSynced to change rather than
// expecting fresh documents back from this call.
export const refreshMkbDocuments = async () => {
  try {
    const email = localStorage.getItem("userId") || "";
    await api.post("/admin/mkb_documents/refresh", null, { params: { email } });
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
